<template>
  <landing-page
    label="factSheet.cervicalCancerTitle"
    labelColor="#603813"
    descColor="#603813"
    :eggImgObj="{ componentName: 'factsheet', imgName: 'cervicalCancerLandingImage', imgFormat: 'png' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightBrownRight', imgFormat: 'svg' }"
  />

  <div id="infoGroup" style="width: 60vw" class="fact-sheet-subpages pt-16 text-2xl font-jost space-y-12 m-auto pb-24">
    <div v-html="t('factSheet.cervicalCancerDesc')" class="space-y-12" />

    <div>
      <div class="font-bold text-description">{{ t("factSheet.riskFactors") }}</div>
      <div v-html="t('factSheet.cervicalCancerRiskFactorsDesc')" class="space-y-5" />
    </div>

    <div>
      <ul class="bullet-big">
        <template v-for="(item, index) in factSheetStore.cervicalCancerRiskFactorsList" :key="'cervicalCancerRiskFactors' + index">
          <li v-html="t(item.label)" />
        </template>
      </ul>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.prevention") }}</div>
      <div v-html="t('factSheet.cervicalCancerPreventionDesc')" class="space-y-5" />
    </div>

    <div>
      <ul class="bullet-big">
        <template v-for="(item, index) in factSheetStore.cervicalCancerPreventionList" :key="'cervicalCancerPrevention' + index">
          <li v-html="t(item.label)" />
        </template>
      </ul>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.symptomsOfCervicalCancer") }}</div>
      <div v-html="t('factSheet.symptomsOfCervicalCancerDesc')" class="space-y-5" />
    </div>

    <div>
      <ul class="bullet-big">
        <template v-for="(item, index) in factSheetStore.cervicalCancerSymptomsList" :key="'cervicalCancerSymptoms' + index">
          <li v-html="t(item.label)" />
        </template>
      </ul>
    </div>

    <div>
      <div v-html="t('factSheet.otherSymptomsInclude')" class="space-y-5" />
      <ul class="bullet-big">
        <template v-for="(item, index) in factSheetStore.cervicalCancerOtherSymptomsList" :key="'cervicalCancerOtherSymptoms' + index">
          <li v-html="t(item.label)" />
        </template>
      </ul>
    </div>

    <div v-html="t('factSheet.cervicalCancerOtherSymptomsDesc')" class="space-y-5" />

    <div>
      <div class="font-bold text-description">{{ t("factSheet.cervicalScreening") }}</div>
      <div v-html="t('factSheet.cervicalScreeningDesc')" class="space-y-5" />
    </div>

    <div>
      <ul class="bullet-big space-y-12">
        <template v-for="(item, index) in factSheetStore.cervicalCancerCervicalScreeningList" :key="'breastCancerHighRiskFactors' + index">
          <li>
            <span v-html="t(item.label)" />
            <ol style="padding-left: 2.2vw !important">
              <template v-for="(listItem, idx) in item.list" :key="'breastCancerHighRiskFactorsSubPoint' + idx">
                <li>{{ t(listItem) }}</li>
              </template>
            </ol>
          </li>
        </template>
      </ul>
    </div>

    <div v-html="t('factSheet.screeningTestDesc')" class="space-y-5" />
    <div v-html="t('factSheet.cervicalCancerRef')" class="space-y-5" />

    <!-- Chinese Version -->
    <section class="!font-sanstc space-y-12">
      <div>
        <div class="font-bold text-description text-center text-4xl">{{ t("factSheetChinese.cervicalCancer") }}</div>
      </div>

      <div v-html="t('factSheetChinese.cervicalCancerDesc')" class="space-y-12" />

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.riskFactors2") }}</div>
        <div v-html="t('factSheetChinese.cervicalCancerRiskFactorsDesc')" class="space-y-5" />
      </div>

      <div>
        <ul class="bullet-big">
          <template v-for="(item, index) in factSheetStore.cervicalCancerRiskFactorsList" :key="'cervicalCancerRiskFactors' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ul>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.prevention") }}</div>
        <div v-html="t('factSheetChinese.cervicalCancerPreventionDesc')" class="space-y-5" />
      </div>

      <div>
        <ul class="bullet-big">
          <template v-for="(item, index) in factSheetStore.cervicalCancerPreventionList" :key="'cervicalCancerPrevention' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ul>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.symptomsOfCervicalCancer") }}</div>
        <div v-html="t('factSheetChinese.symptomsOfCervicalCancerDesc')" class="space-y-5" />
      </div>

      <div>
        <ul class="bullet-big">
          <template v-for="(item, index) in factSheetStore.cervicalCancerSymptomsList" :key="'cervicalCancerSymptoms' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ul>
      </div>

      <div>
        <div v-html="t('factSheetChinese.otherSymptomsInclude')" class="space-y-5" />
        <ul class="bullet-big">
          <template v-for="(item, index) in factSheetStore.cervicalCancerOtherSymptomsList" :key="'cervicalCancerOtherSymptoms' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ul>
      </div>

      <div v-html="t('factSheetChinese.cervicalCancerOtherSymptomsDesc')" class="space-y-5" />

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.cervicalScreening") }}</div>
        <div v-html="t('factSheetChinese.cervicalScreeningDesc')" class="space-y-5" />
      </div>

      <div>
        <ul class="bullet-big space-y-12">
          <template v-for="(item, index) in factSheetStore.cervicalCancerCervicalScreeningList" :key="'breastCancerHighRiskFactors' + index">
            <li>
              <span v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
              <ol style="padding-left: 2.2vw !important">
                <template v-for="(listItem, idx) in item.list" :key="'breastCancerHighRiskFactorsSubPoint' + idx">
                  <li>{{ t(listItem.replace("factSheet", "factSheetChinese")) }}</li>
                </template>
              </ol>
            </li>
          </template>
        </ul>
      </div>

      <div v-html="t('factSheetChinese.screeningTestDesc')" class="space-y-5" />
      <div v-html="t('factSheetChinese.cervicalCancerRef')" class="space-y-5" />
    </section>
  </div>
</template>

<script setup lang="ts">
import { useFactSheetStore } from "@/stores/factSheet";
import { useHeaderStore } from "@/stores/header";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const factSheetStore = useFactSheetStore();
const headerStore = useHeaderStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {
  headerStore.routerName = 'factsheet';
});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>